import { Link } from "react-router-dom";
import { Instagram, Facebook, MessageCircle, Lock } from "lucide-react";
import { useSite } from "@/lib/site";
import { waLink } from "@/lib/api";
import { ZONES } from "@/lib/constants";

export default function Footer() {
  const { settings: s } = useSite();
  return (
    <footer className="bg-[#121316] text-slate-300 mt-24" data-testid="site-footer">
      <div className="container-x py-16 grid gap-12 md:grid-cols-4">
        <div className="md:col-span-2 space-y-4 max-w-md">
          <img src="/brand/logo.png" alt="SoloRentaPC" className="h-24 w-auto bg-white rounded-xl p-1" />
          <p className="text-sm leading-relaxed text-slate-400">{s.footer_text}</p>
          <div className="flex gap-3">
            {s.instagram_url && <a href={s.instagram_url} target="_blank" rel="noreferrer" className="p-2.5 rounded-full bg-white/5 hover:bg-[#FF3333] transition-colors" data-testid="footer-instagram"><Instagram size={18} /></a>}
            {s.facebook_url && <a href={s.facebook_url} target="_blank" rel="noreferrer" className="p-2.5 rounded-full bg-white/5 hover:bg-[#FF3333] transition-colors" data-testid="footer-facebook"><Facebook size={18} /></a>}
            {s.whatsapp && <a href={waLink(s.whatsapp, "Hola SoloRentaPC")} target="_blank" rel="noreferrer" className="p-2.5 rounded-full bg-white/5 hover:bg-[#25D366] transition-colors" data-testid="footer-whatsapp"><MessageCircle size={18} /></a>}
          </div>
        </div>
        <div>
          <h4 className="text-white font-semibold mb-4">Zonas</h4>
          <ul className="space-y-2 text-sm">
            {ZONES.map((z) => <li key={z.slug}><Link to={`/zonas/${z.slug}`} className="hover:text-white">{z.name}</Link></li>)}
          </ul>
        </div>
        <div>
          <h4 className="text-white font-semibold mb-4">SoloRentaPC</h4>
          <ul className="space-y-2 text-sm">
            <li><Link to="/propiedades" className="hover:text-white">Propiedades</Link></li>
            <li><Link to="/publica-tu-propiedad" className="hover:text-white">Soy Propietario</Link></li>
            <li><Link to="/servicios" className="hover:text-white">Directorio de servicios</Link></li>
            <li><Link to="/legal" className="hover:text-white" data-testid="footer-legal-link">Privacidad y términos</Link></li>
            <li className="text-slate-500">{s.instagram}</li>
            <li className="text-slate-500">{s.address}</li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/5 py-6 container-x flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-slate-500">
        <span>© {new Date().getFullYear()} SoloRentaPC. Todos los derechos reservados.</span>
        <Link to="/admin/login" className="inline-flex items-center gap-1.5 text-slate-500 hover:text-white transition-colors" data-testid="footer-admin-login-link"><Lock size={12} />Acceso privado</Link>
      </div>
    </footer>
  );
}
